import React, { Fragment } from 'react';
import { languages } from 'common/constants';

const translations = {
  en: {
    'utils.close': 'Close',
    'menu.aboutUs': 'About us',
    'menu.aboutUsDesc':
      'Squareboard is a digital workplace, combining traditional intranets and social networks features. It’s main goals are: unifying communication and collaboration, increasing productivity, boosting employee engagement, driving business innovation and streamlining processes.',
    'header.enterpriseSolutions': 'Digital Workplace Solutions',
    'menu.features': 'Features',
    'menu.pricing': 'Pricing',
    'menu.offers': 'Plans',
    'menu.contact': 'Contact',
    'menu.pressRelease': 'Press Release',
    'header.digitalWorkplace': 'Your digital workplace.',
    // features
    'features.feed': 'Feed',
    'features.feedDesc': 'Quickly and simply browse the news inside your company.',
    'features.groups': 'Groups',
    'features.groupsDesc': 'Discover working spaces, get in touch with other co-workers.',
    'features.applications': 'Applications',
    'features.applicationsDesc': 'Organise events, publish galleries, upload videos, store your files, and much more.',
    'features.customization': 'Customization',
    'features.customizationDesc': 'Create your own platform identity, keep your image how you want it to be.',
    'features.userManagement': 'User management',
    'features.userManagementDesc': 'Get informations on a person quickly, and simply.',
    'features.mobile': 'Mobile',
    'features.mobileDesc': 'Stay connected and up to date on the move.',
    // Why Squareboard
    'why.whySquareboard': 'Why squareboard',
    'why.communicate': 'Communicate',
    'why.communicateDesc':
      'Get in touch with employees easily. Let them know about what is happening inside the company, and get their feedback as well.',
    'why.unify': 'Unify',
    'why.unifyDesc':
      'Create interaction around your content easily. Organise events, publish galleries of pictures. Get your employees together with groups, and have them discover new content inside the company.',
    'why.accomplish': 'Accomplish',
    'why.accomplishDesc':
      'Create working groups, create shortcuts, and store files. Manage your employees and get their informations quickly. And much more !',
    // Environment
    'env.completeEnvironment': 'A complete environment',
    'env.multiLang': 'Multi-language',
    'env.chat': 'Chat',
    'env.notifications': 'Notifications',
    'env.mailers': 'Mailers',
    'env.pages': 'Pages',
    'env.quickLinks': 'Quick links',
    'env.mustRead': 'Must read',
    'env.videos': 'Videos',
    'env.bookings': 'Bookings',
    'env.files': 'Files',
    'env.polls': 'Polls',
    'env.galleries': 'Galleries',
    'env.events': 'Events',
    'env.news': 'News',
    'env.locations': 'Locations',
    'env.announcements': 'Announcements',
    'env.publicContent': 'Public contents',
    'env.digest': 'Digest',
    // Offers
    'offers.ourOffers': 'Our offer',
    'offers.full': 'Enterprise',
    'offers.light': 'Starter',
    'offers.fullDesc': 'All functionnalities ! The most powerful Squareboard.',
    'offers.lightDesc': 'Squareboard, bare-bones. You use just what you need.',
    'offers.noEncryptedVault': 'No encrypted vault',
    'offers.noGuests': 'No guests groups and guests users',
    'offers.noHR': 'No HR functionnalities',
    'offers.noWorkflows': 'No workflows',
    'offers.singleLicence': 'Single licence',
    'offers.onlyShared': 'Only Shared Cloud',
    'offers.oneYearContracts': 'Maximum 1 year of engagement',
    'offers.GDPR': 'GDPR compliant',
    'offers.hostedInLuxembourg': 'Hosted in Luxembourg',
    'offers.applicationsAvalaible': 'iOS & Android app',
    'offers.multipleLicenceTypes': 'Several types of licenses',
    'offers.unlimitedStorage': 'Unlimited storage',
    'offers.customisation': 'Personalized branding',
    'offers.frequentUpdates': 'Frequent updates',
    'offers.userAndAdminSupport': 'User and administrator support',
    'offers.vaultEndToEnd': 'Vault with end-to-end encryption (option)',
    'offers.customFeatures': 'Customized features & integrations (option)',
    // Pricing
    'pricing.userQuantity': 'Quantity of users',
    'pricing.perUserPerMonth': 'per user/month',
    'pricing.euroPerMonth': '€ / per month',
    'pricing.simulation': 'Pricing simulation',
    'pricing.ourHostingModels': 'Hosting options',
    'pricing.ourPricingModel': 'Our pricing model',
    'pricing.ourPricingModelDesc': 'Our pricing model is calculated on a cumulative basis, each pricing level being calculated independently.',
    'pricing.private': 'Private Cloud',
    'pricing.perUserMonth': 'Per user/month',
    'pricing.shared': 'Shared Cloud',
    'pricing.onPremise': 'On premise',
    'pricing.requestQuotation': 'Request quotation',
    'pricing.phoneSupport': 'Technical and user support',
    'pricing.depractive':
      'All of our prices are depractive depending on the quantity of user, the licences types and the length of engagement.',
    'pricing.hosting': () => (
      <Fragment>
        All of your data in the <b>Private Cloud</b> and <b>Shared Cloud</b> plans are hosted in Luxembourg inside tier
        IV datacenters.
      </Fragment>
    ),
    'pricing.fullPricingDesc': onClick => (
      <Fragment>
        Due to the number of parameters to be taken into account (type of hosting, duration of the commitment, number of users, different types of licenses, ...), we are not able to provide an automatic quotation system.
        <br />Please feel free to request a quotation directly with us <span
          className="zs-button zs-button--link"
          role="presentation"
          onClick={onClick}
        >here.
        </span>
      </Fragment>
    ),
    'pricing.averagePrice': 'Average customers price.',
    'pricing.storageLimit': () => (
      <div style={{ textAlign: 'center' }}>
        The storage volume is said to be "unmetered", i.e. unlimited.
        <div>However, this guarantee can only be applied in the context of a prudent use.</div>
      </div>
    ),
    // Contact
    'contact.contactUs': 'Contact us',
    'contact.firstName': 'First name',
    'contact.lastName': 'Last name',
    'contact.email': 'Email',
    'contact.message': 'Type your message/question here, we answer very quickly.',
    'contact.send': 'Send',
    'contact.downloadBrochure': 'Download our brochure',
    'contact.contactDesc': () => (
      <Fragment>
        Please feel free to contact us with any questions or inquieries. We'll get back to you quickly. You can also
        reach us on
        <b>
          <a href="tel:00352260931"> +352 26 09 31 </a>
        </b>
        or use the contact form below.
      </Fragment>
    ),
    'contact.emailRequired': 'Email required',
    'contact.messageRequired': 'Message required',
    'contact.messageSent': "We have received your contact request ! We'll be in touch soon !",
    // Trust
    'trust.theyTrustUs': 'They trust us',
    // Footer
    'footer.getInTouch': 'Get in touch',
    'footer.headquarter': 'Headquarter',
    'footer.office': 'Office',
    'footer.aProductBy': 'A product by',
    // Language
    'lang.language': 'Language',
  },
  fr: {
    'utils.close': 'Fermer',
    'menu.aboutUs': 'A propos',
    'menu.aboutUsDesc':
      "Squareboard est un espace de travail numérique, qui combine les fonctionnalités des intranets traditionnels et des réseaux sociaux. Ses principaux objectifs sont les suivants : harmoniser la communication, accroître la productivité, stimuler l'engagement des employés, stimuler l'innovation dans les entreprises et rationaliser les processus.",
    'menu.features': 'Fonctionnalités',
    'menu.pricing': 'Tarification',
    'menu.offers': 'Offres',
    'menu.contact': 'Contact',
    'menu.pressRelease': 'Communiqué de presse',
    'header.digitalWorkplace': 'Votre espace de travail digital.',
    // features
    'features.feed': "Flux d'activité",
    'features.feedDesc': 'Accédez simplement et rapidement aux news de votre entreprise.',
    'features.groups': 'Groupes',
    'features.groupsDesc': 'Découvrez des groupes de travail, entrez en contact avec vos collègues.',
    'features.applications': 'Applications',
    'features.applicationsDesc':
      'Organisez des évènements, publiez des galeries, uploadez vos vidéos, stockez vos fichiers ... et bien plus.',
    'features.customization': 'Personnalisation',
    'features.customizationDesc': 'Créez votre propre identité visuelle, obtenez le design que vous souhaitez.',
    'features.userManagement': 'Gestion des utilisateurs',
    'features.userManagementDesc':
      "Obtenez des informations sur une personne simplement et rapidement. L'annuaire d'entreprise au sein de votre intranet.",
    'features.mobile': 'Mobile',
    'features.mobileDesc': 'Restez connectés même en mobilité.',
    // Why Squareboard
    'why.whySquareboard': 'Pourquoi Squareboard',
    'why.communicate': 'Communiquer',
    'why.communicateDesc':
      "Entrez en contact avec vos employés simplement. Informez les des nouvelles aux sein de l'entreprise et obtenez leurs retours.",
    'why.unify': 'Unifier',
    'why.unifyDesc':
      "Créez de l'interaction autour de votre contenu. Organisez des évènements, publiez des galleries de photos ... Regroupez vos employés dans les groupes et augmentez le dynamisme de votre entreprise !",
    'why.accomplish': 'Accomplir',
    'why.accomplishDesc':
      "Créez des groupes de travail, des raccourcis, stockez vos fichiers ... Gérez vos employés et leurs informations rapidement. Un panel d'outil à pour augmenter votre efficacité !",
    // Environment
    'env.completeEnvironment': 'Un environement complet',
    'env.multiLang': 'Multi-langues',
    'env.chat': 'Chat',
    'env.notifications': 'Notifications',
    'env.mailers': 'Mailers',
    'env.pages': 'Pages',
    'env.quickLinks': 'Raccourcis',
    'env.mustRead': 'Lecture requise',
    'env.videos': 'Vidéos',
    'env.bookings': 'Réservations',
    'env.files': 'Fichiers',
    'env.polls': 'Sondages',
    'env.galleries': 'Galeries',
    'env.events': 'Évènements',
    'env.news': 'News',
    'env.locations': 'Lieux',
    'env.announcements': 'Annonces',
    'env.publicContent': 'Contenus publiques',
    'env.digest': 'Newsletter',
    // Offers
    'offers.ourOffers': 'Notre offre',
    'offers.full': 'Enterprise',
    'offers.light': 'Starter',
    'offers.fullDesc': 'Toutes les fonctionnalités, Squareboard à son maximum.',
    'offers.lightDesc': 'Squareboard, allégé. Utilisez seulement ce dont vous avez besoin.',
    'offers.noEncryptedVault': 'Pas de coffre chiffré',
    'offers.noGuests': 'Pas d\'invités et de groupes invités',
    'offers.noHR': 'Pas de fonctionnalités RH',
    'offers.noWorkflows': 'Pas de workflows',
    'offers.singleLicence': 'Licence unique',
    'offers.onlyShared': 'Uniquement en Cloud Partagé',
    'offers.oneYearContracts': '1 an d\'engagement maximum',
    'offers.GDPR': 'Conforme au réglement RGPD',
    'offers.hostedInLuxembourg': 'Hébergé au Luxembourg',
    'offers.applicationsAvalaible': 'Application iOS & Android',
    'offers.multipleLicenceTypes': 'Plusieurs types de licences',
    'offers.unlimitedStorage': 'Stockage illimité',
    'offers.customisation': 'Identité visuelle personnalisée',
    'offers.frequentUpdates': 'Mises à jour régulières',
    'offers.userAndAdminSupport': 'Support utilisateurs et administrateurs',
    'offers.vaultEndToEnd': 'Coffre avec encryption de bout en bout (option)',
    'offers.customFeatures': 'Fonctionnalités sur mesure & intégrations (option)',
    // Pricing
    'pricing.userQuantity': 'Quantité d\'utilisateurs',
    'pricing.perUserPerMonth': 'par utilisateur/mois',
    'pricing.euroPerMonth': '€ / par mois',
    'pricing.simulation': 'Simulation de coût',
    'pricing.ourPricingModel': 'Notre modèle de facturation',
    'pricing.ourHostingModels': 'Possibilités d\'hébergements',
    'pricing.ourPricingModelDesc': 'Notre modèle de prix est calculé sur une base cumulative, chaque niveau de prix étant calculé indépendamment.',
    'pricing.private': 'Cloud Privé',
    'pricing.perUserMonth': 'Par utilisateur/mois',
    'pricing.shared': 'Cloud Partagé',
    'pricing.onPremise': 'On premise',
    'pricing.requestQuotation': 'Demander un devis',
    'pricing.phoneSupport': 'Support technique et support utilisateur',
    'pricing.depractive':
      'Le tarif est dégressif en fonction du nombre d’utilisateurs, de la licence et de la durée d’engagement.',
    'pricing.hosting': () => (
      <Fragment>
        Toutes vos données dans les solutions <b>Cloud Privé</b> et <b>Cloud Partagé</b> sont hébergées au Luxembourg en
        datacenter tier IV.
      </Fragment>
    ),
    'pricing.fullPricingDesc': onClick => (
      <Fragment>
        En raison du nombre de paramètres à prendre en compte (type d’hébergement, durée de l’engagement, nombre d’utilisateurs, différents types de licences, ...), nous ne sommes pas en mesure de fournir un système de devis automatique.
        <br />N'hésitez pas à nous demander un devis directement <span
          className="zs-button zs-button--link"
          role="presentation"
          onClick={onClick}
        >ici.
        </span>
      </Fragment>
    ),
    'pricing.averagePrice': 'Tarif moyen constaté chez nos clients.',
    'pricing.storageLimit': () => (
      <div style={{ textAlign: 'center' }}>
        Le volume de stockage est dit « non métré », c’est à dire illimité.
        <div>
          Cependant, cette garantie ne peut s’appliquer que dans le cadre d’une utilisation en bon père de famille.
        </div>
      </div>
    ),
    // Contact
    'contact.contactUs': 'Contactez nous',
    'contact.firstName': 'Prénom',
    'contact.lastName': 'Nom',
    'contact.email': 'Email',
    'contact.message': 'Écrivez votre message/question ici, nous reviendrons vers vous aussi vite que possible.',
    'contact.send': 'Envoyer',
    'contact.downloadBrochure': 'Télécharger notre brochure',
    'contact.contactDesc': () => (
      <Fragment>
        N'hésitez pas à nous contacter pour toute question ou demandes. Nous reviendrons vers vous rapidement. Vous
        pouvez nous contacter directement par téléphone au
        <b>
          <a href="tel:00352260931"> +352 26 09 31 </a>
        </b>
        ou utiliser le formulaire ci-dessous.
      </Fragment>
    ),
    'contact.emailRequired': 'Email requis',
    'contact.messageRequired': 'Message requis',
    'contact.messageSent': 'Nous avons reçu votre demande de contact ! Nous reviendrons vers vous très bientôt.',
    // Trust
    'trust.theyTrustUs': 'Ils nous font confiance',
    // Footer
    'footer.getInTouch': 'Entrer en contact',
    'footer.headquarter': 'Siège social',
    'footer.office': 'Bureaux',
    'footer.aProductBy': 'Un produit',
    // Language
    'lang.language': 'Langue',
  },
};

export default function i18nReducer(
  state = {
    translations,
    lang:
      !localStorage.getItem('lang')
      && window.navigator.language
      && languages.find(lang => lang.value === window.navigator.language.split('-')[0])
        ? window.navigator.language.split('-')[0]
        : localStorage.getItem('lang')
          ? localStorage.getItem('lang')
          : 'en',
  },
  action,
) {
  switch (action.type) {
    case 'SET_LANG':
      return {
        ...state,
        lang: action.payload.lang,
      };
    default:
      return state;
  }
}
